type DeclarationRecord = Record<string, any>;

const copy = <T,>(value: T): T => JSON.parse(JSON.stringify(value));

const asList = (value: any): any[] => {
  if (Array.isArray(value)) return copy(value);
  if (value === undefined || value === null || value === '') return [];
  return String(value).split(',').map(item => item.trim()).filter(Boolean);
};

/**
 * Builds the editable payload for a replacement declaration.
 *
 * The declaration data itself is copied deeply. Only system/CQT response
 * metadata is reset because it belongs to the rejected declaration and must
 * never be reused for the replacement declaration.
 */
export const cloneDeclarationForCreate = (
  source: DeclarationRecord,
  createdAt: Date | string = new Date(),
): DeclarationRecord => {
  const sourceCopy = copy(source || {});

  return {
    ...sourceCopy,
    id: null,
    sourceDeclarationId: sourceCopy.id || null,
    status: 0,
    // Clone ngày lập của tờ khai gốc; chỉ fallback về ngày hiện tại khi API không trả dateCreate.
    dateCreate: createdAt instanceof Date ? new Date(createdAt) : new Date(createdAt),
    dateSign: null,
    signedAt: null,
    signatureHash: null,
    notificationCode: null,
    taxAuthorityNotificationCode: null,
    notificationStatus: '',
    taxAuthorityFeedback: null,
    taxAuthorityFeedbackName: '',
    authType: null,
    authDeadline: null,
    LTTXThuc: null,
    lttxThuc: null,
    THXThuc: null,
    thxThuc: null,
    rejectionReason: '',
    nextStep: null,
    nextStepCode: null,
    nextStepLabel: null,
    // Không giữ lại loại bước tiếp theo của tờ khai bị từ chối khi tạo tờ khai mới.
    nextStepType: null,
    nextStepAction: null,
    nextStepClickable: false,
    nextStepGuideType: null,
    formInvoice: asList(sourceCopy.formInvoice),
    formSendData: asList(sourceCopy.formSendData),
    invoiceTypeUse: asList(sourceCopy.invoiceTypeUse),
    method: asList(sourceCopy.method),
    token: copy(sourceCopy.token || []),
    partners: copy(sourceCopy.partners || []),
    dependentUnits: copy(sourceCopy.dependentUnits || []),
    integrations: copy(sourceCopy.integrations || []),
    suspensions: copy(sourceCopy.suspensions || []),
  };
};

export const declarationFormFields = [
  'formality',
  'dateCreate',
  'region',
  'taxpayers',
  'taxCode',
  'taxAuthorityName',
  'legalRepName',
  'legalRepPhone',
  'legalRepIdentificationNumber',
  'legalRepPassport',
  'legalRepDob',
  'legalRepGender',
  'personContact',
  'phone',
  'address',
  'email',
  'formInvoice',
  'formSendData',
  'method',
  'invoiceTypeUse',
] as const;
